import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { Button, Form, FormProps } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import FileInput from '../FileInput';
import Select from '../Select';
import TextInput from '../TextInput/TextInput';

export type DocumentUpload = {
  category: string;
  topic: string;
  additionalNotes: string;
  file: File;
};

export type UploadDocFormProps = FormProps &
  React.PropsWithChildren<{
    handleClose: () => void;
    handleOnSubmit: (formData: DocumentUpload) => void;
  }>;

const UploadDocForm = ({ handleClose, handleOnSubmit }: UploadDocFormProps) => {
  const options = [
    { value: '1', label: 'Pension' },
    { value: '2', label: 'Other' },
  ];

  const validationSchema = yup.object().shape({
    category: yup.string().required('Category is required'),
    topic: yup
      .string()
      .required('Topic is required')
      .max(245, 'Must be no longer than 245 characters'),
    additionalNotes: yup.string(),
    file: yup.mixed().required('File is required'),
  });

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleSubmitForm = (formData: any) => {
    handleOnSubmit(formData);
    //handleClose();
  };

  return (
    <form onSubmit={handleSubmit(handleSubmitForm)} noValidate={true}>
      <Form.Label className="text-fs-6 fw-normal lh-xs">Category</Form.Label>
      <Controller
        name={'category'}
        control={control}
        rules={{ required: true }}
        render={({ field }) => <Select options={options} {...field} />}
      />
      {errors.category && (
        <div className="error-message">
          <span>{errors.category.message}</span>
        </div>
      )}
      <Form.Label className="pt-10 text-fs-6 fw-normal lh-xs">Topic</Form.Label>
      <Controller
        name={'topic'}
        control={control}
        render={({ field }) => (
          <TextInput {...field} placeholder={'Enter topic'} />
        )}
      />
      {errors.topic && (
        <div className="error-message">
          <span>{errors.topic.message}</span>
        </div>
      )}
      <Form.Label className="pt-10 text-fs-6 fw-normal lh-xs">
        Additional Notes
      </Form.Label>
      <Controller
        name={'additionalNotes'}
        control={control}
        render={({ field }) => (
          <Form.Control
            as="textarea"
            className="lh-sm border-info fw-light text-fs-6"
            aria-label="With textarea"
            placeholder="Type here.."
            {...field}
          />
        )}
      />
      <Form.Label className="pt-10 text-fs-6 fw-normal lh-xs">
        Add Files
      </Form.Label>
      <Controller
        name={'file'}
        control={control}
        render={({ field }) => (
          <FileInput
            {...field}
            placeholder={'filename.pdf'}
            className="mw-100 mr-2"
          />
        )}
      />
      {errors.file && (
        <div className="error-message">
          <span>{errors.file.message}</span>
        </div>
      )}
      <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
        <Button
          className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1"
          variant="primary-outline"
          onMouseDown={handleClose}
        >
          Cancel
        </Button>
        <Button variant="primary" className="order-1 order-lg-2" type="submit">
          Upload
        </Button>
      </section>
    </form>
  );
};

export default UploadDocForm;
